import { isNotNullish } from '@nx/stdlib';

type RelateError = { data: { errors: ErrorInfo[] } };

type NestjsError = { data: string };

type ErrorInfo = { message: string };

export const isRelateError = (errorResponse: unknown): errorResponse is RelateError => {
  if (
    errorResponse !== null &&
    typeof errorResponse === 'object' &&
    isNotNullish(errorResponse) &&
    'data' in errorResponse
  ) {
    const { data } = errorResponse;
    if (data !== null && typeof data === 'object' && isNotNullish(data) && 'errors' in data) {
      const { errors } = data;
      if (Array.isArray(errors) && errors.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const [error] = errors;
        if (isNotNullish(error) && typeof error === 'object' && 'message' in error) {
          return true;
        }
      }
    }
  }
  return false;
};

export const isNestjsError = (errorResponse: unknown): errorResponse is NestjsError => {
  if (
    errorResponse !== null &&
    typeof errorResponse === 'object' &&
    isNotNullish(errorResponse) &&
    'data' in errorResponse
  ) {
    const { data } = errorResponse;
    if (typeof data === 'string') {
      return true;
    }
  }
  return false;
};

export const getRelateErrors = (error: unknown): string | null => {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (isRelateError(error)) {
    return error.data.errors.map((e) => e.message).join('\n');
  }

  if (isNestjsError(error)) {
    return error.data;
  }

  return null;
};
